<template>
  <div class="Detalis">
    <navigator title="账单详情"></navigator>
    <div>
    <div class="bigBox">
      <h3>订单号：{{welfareinfo.order_id}}</h3>
      <p class="one">申请者信息<span class="iner">订单状态：{{welfareinfo.order_status?orderStatusAll[welfareinfo.order_status] : handleStatusList[0]}}</span></p>
      <p>联系人：{{welfareinfo.apply_name}}<span class="iner">订单金额：<span class="color">¥ {{welfareinfo.approval_fee>0?welfareinfo.approval_fee:welfareinfo.order_fee}}</span></span></p>
      <p>联系电话：{{welfareinfo.apply_phone}}</p>
      <p>职位：{{welfareinfo.apply_position}}</p>
      <p>企业名称：{{welfareinfo.corp_name}}</p>
    </div>
    <div class="bigBox">
      <h3>订单详情</h3>
      <p class="one">表单信息</p>
      <p class="fbox" v-for="(item, index) in boxinfo" :key="index">
        {{item.title}}:<span v-if="item.type!=7">{{item.value}}</span><img v-else :src='item.value' alt="">
      </p>
      <p class="two">订单信息</p>
      <p>订单ID：{{welfareinfo.order_id}}</p>
      <p>服务名称：{{welfareinfo.title}}</p>
      <p>订单状态：{{welfareinfo.order_status?orderStatusAll[welfareinfo.order_status] : handleStatusList[0]}}</p>
      <p>下单时间：{{welfareinfo.create_time}}</p>
      <p>预计费用：{{welfareinfo.order_status?welfareinfo.order_fee:welfareinfo.approveFee}}</p>
      <p>核准金额：{{welfareinfo.order_status?welfareinfo.approval_fee:welfareinfo.approveFee}}</p>
      <p>支付金额：{{welfareinfo.payment.length ? welfareinfo.payment[0].pay_fee : ''}}</p>
      <p>支付方式：{{welfareinfo.payment.length ? payTypeList[welfareinfo.payment[0].pay_type] : ''}}</p>
      <p>支付单号：{{welfareinfo.payment.length ? welfareinfo.payment[0].trade_no : ''}}</p>
      <p>支付时间：{{welfareinfo.payment.length ? welfareinfo.payment[0].create_time : ''}}</p>
    </div>
    <div class="bigBox ping">
      <h3>用户评价</h3>
      <van-rate void-icon="star" v-model="value" readonly />
    </div>
  </div>
  </div>
</template>
<script>
import Navigator from '@/components/Navigator';
import { mapGetters, mapMutations } from 'vuex';
import { MessageBox, Toast } from 'mint-ui';

export default {
  data() {
    return{
      welfareinfo: {},
      boxinfo:{},
      value: 3,
      orderStatusAll:[
        '全部',
        '待审批',
        '审批中',
        '审批不通过',
        '用户取消',
        '待支付',
        '完成',
        '订单关闭',
        '已退款',
        '退款中',
      ],
      handleStatusList :[
        '待处理', '同意', '不同意',
      ],
      payTypeList :[
        '全部',
        '微信支付',
        '月结',
      ],
    }
  },
  methods: {
    getinfo() {  // 流水详情
      this.$http.post(`${this.URL_PREFIX}/mgmt/park/order/detail`, {
        park_id: this.currentParkId,
        order_id:this.$route.params.BillDetalisId,
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.welfareinfo = res.data.resData;
          this.boxinfo = res.data.resData.parkServiceFormOrder.content;
          console.log(this.boxinfo);
          this.value = res.data.resData.services_score;
        }
      });
    },
  },
  mounted() {
    this.getinfo();
  },
  components: {
    Navigator,
  },
  computed: {
    ...mapGetters(['currentParkId','token','qrcodeServiceInfo']),
  },
}
</script>
<style lang="scss" scoped>
@import '~@scss';
.bigBox{
  margin: .38rem;
  border-bottom: 1px solid #ccc;
  padding-bottom: .5rem;
  h3{
    font-size: .5rem;
    font-weight: 600;
    margin-bottom: .23rem;
  }
  .one{
    margin-bottom: .18rem;
  }
  .two{
    margin: .58rem 0 .18rem 0;
  }
  .fbox{
    img{
      width: 88%;
    }
  }
  p{
    margin-bottom: .06rem;
    font-size: .36rem;
    .iner{
      float: right;
      .color{
        color: red;
      }
    }
  }
}
.ping{
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/pages/personal/detalis/BillDetalis.vue